import { getFacilityByIdQueryOptions } from '@/entities/facility';
import { InfoCard } from '@/shared/components';
import { useQuery } from '@tanstack/react-query';
import type { FC } from 'react';

export type InfoCard3Props = {
  facilityId: string;
};

export const InfoCard3: FC<InfoCard3Props> = ({ facilityId }) => {
  const { data: facility, isLoading } = useQuery(
    getFacilityByIdQueryOptions({ facilityId: +facilityId })
  );

  return (
    <InfoCard
      height={116}
      list={[
        {
          id: 'beds',
          label: `${facility?.totalBeds ?? 'N/A'} beds`,
          icon: 'bed',
        },
        {
          id: 'residents',
          label: `${facility?.activeResidentsCount ?? 'N/A'} residents`,
          icon: 'id-card',
        },
        {
          id: 'staff',
          label: `${facility?.totalStaff ?? 'N/A'} staff`,
          icon: 'team',
        },
      ]}
      loading={isLoading}
    />
  );
};
